// Mimaussy Custom JS

// Mobile menu: click to menu item use parent behaviour  
document.addEventListener('DOMContentLoaded', function () {
	document.querySelectorAll('summary a[href="#"]').forEach(function (link) {
		link.addEventListener('click', function (event) {
			event.preventDefault(); // prevent link
			const summary = link.closest('summary');
			if (summary && summary.parentNode && summary.parentNode.nodeName === 'DETAILS') {
				const details = summary.parentNode;
				details.open = !details.open;
			}
		});
	});
});


// Mobile menu: swap menus "main" with "short main"
document.addEventListener('DOMContentLoaded', function () {
    const nav = document.querySelector('.menu-drawer__navigation'); 
    const menus = nav.querySelectorAll('ul.menu-drawer__menu.list-menu');

    if (menus.length >= 2) {
        const firstMenu = menus[0]; const secondMenu = menus[1];

        const temp = document.createElement('div');
        firstMenu.parentNode.insertBefore(temp, firstMenu);

        secondMenu.parentNode.insertBefore(firstMenu, secondMenu.nextSibling);

        temp.parentNode.insertBefore(secondMenu, temp);

        temp.remove();
    }
});
